export enum CAMPAIGN_EVENTS {
  CAMPAIGNS_SYNC_SUCCESS = 'CAMPAIGNS_SYNC_SUCCESS',
  CAMPAIGNS_SYNC_FAILED = 'CAMPAIGNS_SYNC_FAILED',
}
